export const SUBSCRIPTION_GATE_LABELS = Object.freeze({
  staffTitle: "Hub subscription needed",
  staffDescription:
    "Ask the hub owner to activate or renew the subscription so you can keep using this workspace.",
  logout: "Log out",
  loadingCatalog: "Checking plan access...",
  catalogUnavailableTitle: "Couldn't verify your plan",
  catalogUnavailableDescription:
    "We couldn't load plan details right now. Please try again in a moment.",
  retry: "Retry",
  featureUnavailableTitle: "This feature isn't on your current plan",
  featureUnavailableOrLimitTitle:
    "This feature isn't on your current plan or the max store limit is consumed",
  featureUnavailableDescription:
    "You can upgrade or change your plan to unlock.",
  manageSubscription: "View plans",
  navigationUnavailable: "Not included in your current plan",
  checkingStoreLimit: "Checking your plan limit...",
  ownerOnlyCreate: "Only the hub owner can create or restore a business.",
  storeLimitReached: (limit) =>
    `Your current plan allows up to ${limit} active businesses.`,
});
